import React from "react";
import { IoMdArrowUp } from "react-icons/io";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { useIsMobile } from "../../hooks/useIsMobile";
import { ourRatingsAndReviewsData } from "../../utils/constants/Team";
import { handleOfficeReviewClickEvent } from "../../utils/helperEventFunctions";
import Fade from "react-reveal/Fade";
import UserRatingStar from "../Icons/LandingPage/UserRatingStar";
import HalfRatingStar from "../Icons/HalfRatingStar";
import CustomNextImage from "../common/CustomNextImage";

const OurRatingsAndReviews = () => {
  const { isMobile } = useIsMobile();
  const router = useRouter();
  const firebaseUID = useSelector((state) => state.currentUser.firebaseUID);
  const sourceScreen = router?.query ? router?.asPath : router?.pathname;

  const handleRatingsClicked = ({ title }) => {
    handleOfficeReviewClickEvent({
      firebaseUID,
      sourceScreen,
      status: title,
      deviceCategory: isMobile ? "mobile" : "desktop",
    });
  };
  return (
    <section>
      <Fade bottom>
        <h6 className="text-[24px] font-lexend font-semibold text-center lg:text-[40px]">
          Our Ratings & Reviews
        </h6>
      </Fade>
      <div className="mt-8 flex flex-col md:flex-row justify-center items-center gap-6">
        {ourRatingsAndReviewsData.map((item) => {
          return (
            <div
              key={item?.title}
              className="group relative flex flex-col items-center justify-center text-center w-full md:w-fit lg:w-fit rounded-xl border border-[#2e0a4f] bg-gradient-to-b from-[#2e0a4f] via-[#200737] to-[#160526] p-6 hover-float hover:border-[#472f5d] transition"
            >
              <div className="border-[.5px] bg-white/100 border-[#a0a0aa] backdrop-blur-md p-3 text-center w-fit rounded-lg mb-4">
                <CustomNextImage
                  src={item?.image}
                  alt={item?.title}
                  width={500}
                  height={500}
                  className="w-[100px] mx-auto transform transition-transform duration-700 group-hover:scale-[1.1]"
                />
              </div>
              <div className="flex items-center gap-1 text-yellow-400 !text-[10px] lg:!text-[16px]">
                {Array.from({ length: 4 }, (_, i) => (
                  <span key={i}>
                    <UserRatingStar className="w-[10px] lg:w-[16px]" />
                  </span>
                ))}
                <span>
                  <HalfRatingStar className="w-[10px] lg:w-[16px]" />
                </span>
              </div>
              <div className="p-[1px] rounded-full bg-gradient-to-r from-[#9a30bf] via-[#7330bf] to-[#7330bf] w-fit mt-5 md:!mt-7">
                <a href={item?.url} target="_blank" rel="noreferrer">
                  <button
                    onClick={() => handleRatingsClicked({ title: item?.title })}
                    className="font-lexend !normal-case border-0 flex items-center pl-3 py-2 pr-4 rounded-full gap-x-2 bg-[#262529] text-[12px] lg:text-[16px] lg:px-[24px]"
                  >
                    Check out our reviews on {item?.title}
                    <IoMdArrowUp className="rotate-45 text-[16px] lg:text-[18px]" />
                  </button>
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default OurRatingsAndReviews;
